module.exports = __webpack_public_path__ + "static/img/tab4spic.a8ee007f.png";